export interface SavedSegment {
  id: number;
  name: string;
  description: string;
  filterCount: number;
  audienceSize: number;
  isDefault: boolean;
  createdAt: string;
}

export interface SegmentStats {
  totalSize: number;
  totalInteractions: number;
  avgEngagementRate: number;
}

export interface Distribution {
  label: string;
  value: number;
  percentage: number;
}

export const mockSavedSegments: SavedSegment[] = [
  {
    id: 1,
    name: 'Basketball Fans 18-24',
    description: 'Young basketball enthusiasts in urban areas',
    filterCount: 5,
    audienceSize: 45000,
    isDefault: true,
    createdAt: '2026-01-15',
  },
  {
    id: 2,
    name: 'Premium Sports Audience',
    description: 'High-income sports fans interested in luxury brands',
    filterCount: 8,
    audienceSize: 32000,
    isDefault: false,
    createdAt: '2026-01-20',
  },
  {
    id: 3,
    name: 'Female Football Fans',
    description: 'Women interested in football content',
    filterCount: 3,
    audienceSize: 28000,
    isDefault: false,
    createdAt: '2026-01-25',
  },
];

export const mockSegmentStats: SegmentStats = {
  totalSize: 45000,
  totalInteractions: 2500000,
  avgEngagementRate: 3.8,
};

export const mockGenderDistribution: Distribution[] = [
  { label: 'Male', value: 27000, percentage: 60 },
  { label: 'Female', value: 18000, percentage: 40 },
];

export const mockAgeDistribution: Distribution[] = [
  { label: '18-24', value: 20250, percentage: 45 },
  { label: '25-34', value: 15750, percentage: 35 },
  { label: '35-44', value: 6750, percentage: 15 },
  { label: '45+', value: 2250, percentage: 5 },
];

export const mockLocationDistribution: Distribution[] = [
  { label: 'Brazil', value: 15750, percentage: 35 },
  { label: 'Portugal', value: 13500, percentage: 30 },
  { label: 'USA', value: 9000, percentage: 20 },
  { label: 'Spain', value: 4500, percentage: 10 },
  { label: 'Other', value: 2250, percentage: 5 },
];

export const mockLifestyleDistribution: Distribution[] = [
  { label: 'Sports Enthusiast', value: 22500, percentage: 50 },
  { label: 'Urban Professional', value: 11250, percentage: 25 },
  { label: 'Student', value: 6750, percentage: 15 },
  { label: 'Content Creator', value: 4500, percentage: 10 },
];

export const mockInterestsDistribution: Distribution[] = [
  { label: 'Basketball', value: 31500, percentage: 70 },
  { label: 'Football', value: 18000, percentage: 40 },
  { label: 'Fitness', value: 13500, percentage: 30 },
  { label: 'Fashion', value: 9000, percentage: 20 },
  { label: 'Music', value: 6750, percentage: 15 },
];
